import {
    convertUniversalDateTimeToPersianDateTime, DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridOneColumn, RaikoTableTitleContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {ResidencesManagerService} from "../../serverService/residencesManagerService/ResidencesManagerService";
import {Helmet} from "react-helmet";
import AddNewResidenceManager from "./addNewResidenceManager/AddNewResidenceManager";
import {useNavigate} from "react-router-dom";

export default function ResidencesManager() {

    let selectedItemID = -1;
    let page = 0;
    const size = 20;

    const service = new ResidencesManagerService();


    const [residencesManagerData, setResidencesManagerData] = useState([]);
    const [numberOfItems, setNumberOfItems] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);

    const [openDialog, setOpenDialog] = useState(false)
    const [isNeedRefresh, setIsNeedRefresh] = useState(false)


    useEffect(() => {
        if (typeof service !== "undefined") {
            getResidencesManagerListFromServer()
        }
    }, []);

    function tablePreparation(number, id, clerkFullName, username, phoneNumber, createdBy, createdAt) {
        return {
            number,
            id,
            clerkFullName,
            username,
            phoneNumber,
            createdBy,
            createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
        }
    }

    function getResidencesManagerListFromServer() {
        setIsLoading(true)
        service.getResidencesManagerList(page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setResidencesManagerData([])
                response.data.map((item, index) => {
                    setResidencesManagerData(prevState => [
                        ...prevState,
                        tablePreparation(
                            (page * size) + index + 1,
                            item.id,
                            item.metaData.fullName,
                            item.username,
                            item.phoneNumber,
                            item.createdBy,
                            item.createdAt
                        )
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    function handleChangePage(newPage) {
        page = newPage;
        getResidencesManagerListFromServer()
    }

    function handleCloseDialog() {
        setOpenDialog(false)
        if (isNeedRefresh) {
            page = 0;
            getResidencesManagerListFromServer();
            setIsNeedRefresh(false);
        }
    }

    function addNewResidenceManager() {
        selectedItemID = -1;
        setOpenDialog(true)
    }

    const navigate = useNavigate()

    function showResidenceManagerInfo(id) {
        let _title = ""
        residencesManagerData.map((item) => {
            if (item.id === id)
                _title = item.clerkFullName
        })

        navigate(
            RouteHelper.ResidencesManagerInfo.globalUrl.replace(":id", id),
            {state: {title: _title}, replace: false}
        )
    }

    return (
        <>
            <Helmet><title>{RouteHelper.ResidencesManager.name}</title></Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={""}
            >
                <AddNewResidenceManager needRefreshState={setIsNeedRefresh}/>
            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(RouteHelper.Habitation.name, ""),
                        raikoBreadCrumbItemGenerator(RouteHelper.ResidencesManager.name, ""),
                    ]}/>
                </RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"خدام"}
                            amount={numberOfItems}
                            hasCreateNewItem={true}
                            handleCreateNewItem={addNewResidenceManager}
                        />
                        <RaikoCustomTable
                            header={residenceManagerTableHeader}
                            data={residencesManagerData}
                            isLoading={isLoading}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePage}
                            rowClicked={showResidenceManagerInfo}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>
        </>

    )
}

export const residenceManagerTableHeader = [
    {
        id: "number",
        label: "#"
    }, {
        id: "clerkFullName",
        label: "نام و نام خانوادگی"
    }, {
        id: "username",
        label: "نام کاربری"
    }, {
        id: "phoneNumber",
        label: "شماره همراه"
    }, {
        id: "createdBy",
        label: "سازنده"
    }, {
        id: "createdAt",
        label: "تاریخ ساخت"
    },
]